import {
  DISCOUNT_VALIDATE_REQUEST,
  DISCOUNT_VALIDATE_SUCCESS,
  DISCOUNT_VALIDATE_FAIL,
} from "../Constants/DiscountConstants";
import URL from "../Url";

// POST /api/discounts/validate
export const validateDiscount =
  (code, orderAmount) => async (dispatch, getState) => {
    try {
      dispatch({ type: DISCOUNT_VALIDATE_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const res = await fetch(`${URL}/api/discounts/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
        body: JSON.stringify({ code, orderAmount }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Invalid discount code");
      }

      dispatch({ type: DISCOUNT_VALIDATE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: DISCOUNT_VALIDATE_FAIL,
        payload: error.message || "Invalid discount code",
      });
    }
  };